import { useEffect, useMemo } from 'react';
import { Button, getActionEventTarget } from '@amzn/aac-chrome-api';
import { AACButtonProps } from '@urc-ui/hooks/aac-button/types';

const useAACButton = (props: AACButtonProps) => {
  useEffect(() => {
    const actionEventTarget = getActionEventTarget();
    actionEventTarget.addEventListener(props.id, props.onClick);

    return () => actionEventTarget.removeEventListener(props.id, props.onClick);
  }, [props.onClick]);

  return useMemo(() => {
    const button = new Button();
    button.setId(props.id);
    button.setButtonType(props.type);

    button.setState(props.state);
    button.setLabel(props.label);
    button.setToolTip(props.tooltip);
    button.setTooltipPosition(props.tooltipPosition);

    return button;
  }, [props.id, props.label, props.tooltip, props.type, props.state, props.tooltipPosition]);
};

export { useAACButton };
